import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { localize } from 'src/l10n';
import { SpintrTypes } from 'src/typings';
import { Label } from 'src/ui';
import "./AppDisabledBanner.scss";
import Visage2Icon from 'src/visage2/Visage2Icon/Visage2Icon';
import { Link } from "react-router-dom";

export type StateProps = {
    isAdmin: boolean;
    appMode: boolean;
    academyAppName: string;
    apps: Spintr.ISystemApp[];
};

interface AppDisabledBannerProps {
    type: string;
}

const AppDisabledBanner = (props: AppDisabledBannerProps) => {
    const [showBanner, setShowBanner] = useState<boolean>(false);
    const [trial, setTrial] = useState<boolean>(false);

    const { isAdmin, apps, appMode, academyAppName } = useSelector<Spintr.AppState, StateProps>(
        (appState) => ({
            isAdmin: appState.profile.active.roles.includes("administrators"),
            apps: appState.app.items,
            appMode: appState.ui.appMode,
            academyAppName: appState.instance.get("academyAppName"),
        })
    );

    const header = academyAppName ? localize(props.type) : academyAppName;

    useEffect(() => {
        let shouldShow = false;
        let app: Spintr.ISystemApp;

        if (props.type === localize(academyAppName, true)) {
            app = apps.find((app) => app.id === SpintrTypes.SpintrApp.Academy);
        } else if (props.type === localize("appPlanner")) {
            app = apps.find((app) => app.id === SpintrTypes.SpintrApp.Planner);
        } else if (props.type === localize("appSystemStatus")) {
            app = apps.find((app) => app.id === SpintrTypes.SpintrApp.SystemStatus);
        }

        if (!app) {
            return;
        }

        if (!app.published) {
            shouldShow = true;
        }

        if (isAdmin && shouldShow) {
            setShowBanner(true);
            setTrial(app.trial);
        } else {
            setShowBanner(false);
            setTrial(app.trial);
        }
    }, [isAdmin, apps, props.type]);

    if (!isAdmin || !showBanner) {
        return null;
    }

    const linkToSettings = !appMode ? (
        <Link className={"linkFGColor"} to={`admin/topmenu`}>
            {localize("APP_DISABLED_BANNER_LINK")}
        </Link>
    ) : (
        localize("APP_DISABLED_BANNER_LINK")
    );

    const boldPremiumFeature = (
        <Label size="body-1" color="black" weight="bold" as="span">
            {localize("APP_DISABLED_PREMIUM_BOLD")}
        </Label>
    );

    const appDisabledBannerInfo = localize(trial ? "APP_DISABLED_PREMIUM_BANNER_INFO" : "APP_DISABLED_BANNER_INFO");
    const messageParts = appDisabledBannerInfo.split(/(\{\d+\})/);

    const replacements = {
        "{0}": header,
        "{1}": linkToSettings,
        "{2}": boldPremiumFeature,
    }

    return (
        <div className="AppDisabledBanner">
            <div className="AppDisabledBanner-inner">
                <div className="AppDisabledBanner-info-circle">
                    <Visage2Icon icon="info-circle" />
                </div>
                <Label size="body-1" color="black" weight="normal">
                    {messageParts.map((part) => replacements[part] || part)}
                </Label>
            </div>
        </div>
    );
};

export default AppDisabledBanner;
